/* Last Call urgency: home hero, countdown, stock tags, halo tag.
 * Expects window.LC_DATA = { page: 'home'|'shop', deadline: ISO string, stock: { handle: qty } }
 * Stock numbers come from Liquid (variant.inventory_quantity), the same source as the PDP counter.
 */
(function () {
  var D = window.LC_DATA || {};
  var DEADLINE = new Date(D.deadline || '2026-10-07T23:59:59-04:00').getTime();
  var STOCK = D.stock || {};
  var FLAVORS = [
    { handle: 'strawberry-hibiscus', name: 'Strawberry Hibiscus Tea' },
    { handle: 'cocoa-pomegranate-yuzu', name: 'Cocoa Pomegranate Yuzu' },
    { handle: 'raspberry-basil-lemonade', name: 'Raspberry Basil Lemonade' }
  ];
  /* Each pack holds one four-pack of each listed flavor, so packs left = the lowest flavor's four-packs */
  var PACKS = [
    { handle: 'signature-pack', of: ['strawberry-hibiscus', 'raspberry-basil-lemonade', 'cocoa-pomegranate-yuzu'], unit: 'packs left' },
    { handle: 'mix-match-pack', of: ['strawberry-hibiscus', 'cocoa-pomegranate-yuzu'], unit: 'packs left' },
    { handle: 'the-reset-kit', of: ['cocoa-pomegranate-yuzu', 'raspberry-basil-lemonade'], unit: 'kits left' }
  ];
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var open = Date.now() < DEADLINE;

  var CSS = [
    ':root{--lc-coral:#E55D5C;--lc-deep:#bd3c56;--lc-pink:#f9c9c6;--lc-cream:#fff7eb;--lc-ink:#0f0f0f;}',
    '.lc-hero{background:var(--lc-ink);color:var(--lc-cream);padding:56px 20px 60px;text-align:center;position:relative;overflow:hidden;}',
    '.lc-hero::before{content:"";position:absolute;inset:-40%;background:radial-gradient(circle at 20% 30%,rgba(229,93,92,.28),transparent 40%),radial-gradient(circle at 80% 70%,rgba(249,201,198,.16),transparent 45%);animation:lc-drift 14s ease-in-out infinite alternate;pointer-events:none;}',
    '@keyframes lc-drift{from{transform:translate(0,0)}to{transform:translate(4%,-3%)}}',
    '.lc-hero>*{position:relative;}',
    '.lc-grid{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,760px) minmax(0,1fr);grid-template-areas:"l c r";gap:28px;align-items:center;max-width:1440px;margin:0 auto;}',
    '.lc-center{grid-area:c;}',
    '.lc-side{display:block;justify-self:center;width:100%;max-width:300px;}',
    '.lc-side-l{grid-area:l;}',
    '.lc-side-r{grid-area:r;}',
    '.lc-side img{display:block;width:100%;aspect-ratio:3/4;object-fit:cover;border-radius:24px;box-shadow:0 18px 50px rgba(229,93,92,.35),0 0 0 6px rgba(255,247,235,.08);}',
    '.lc-side-l img{transform:rotate(-5deg);animation:lc-float-l 6s ease-in-out infinite;}',
    '.lc-side-r img{object-position:45% 50%;transform:rotate(5deg);animation:lc-float-r 6.5s ease-in-out infinite;}',
    '@keyframes lc-float-l{0%,100%{transform:rotate(-5deg) translateY(0)}50%{transform:rotate(-3deg) translateY(-14px)}}',
    '@keyframes lc-float-r{0%,100%{transform:rotate(5deg) translateY(-10px)}50%{transform:rotate(3deg) translateY(6px)}}',
    '.lc-burst{position:absolute;top:20px;left:20px;z-index:6;width:240px;height:240px;display:block;pointer-events:none;border-radius:50%;box-shadow:0 10px 24px rgba(0,0,0,.28);animation:lc-pop .7s cubic-bezier(.3,1.6,.5,1) both,lc-bob 3.2s ease-in-out .7s infinite;}',
    '.lc-burst svg{width:100%;height:100%;display:block;overflow:visible;}',
    '.lc-burst text{font:700 13px "greycliff-cf",Arial,sans-serif;letter-spacing:2.4px;fill:#f9c9c6;}',
    '.lc-spin{transform-origin:100px 100px;animation:lc-rot 16s linear infinite;}',
    '@keyframes lc-rot{to{transform:rotate(360deg)}}',
    '@keyframes lc-pop{0%{transform:scale(.2) rotate(-25deg);opacity:0}100%{transform:scale(1) rotate(-8deg);opacity:1}}',
    '@keyframes lc-bob{0%,100%{transform:scale(1) rotate(-8deg)}50%{transform:scale(1.06) rotate(-4deg)}}',
    '.lc-burst-txt{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;font-family:"Recoleta-SemiBold",Georgia,serif !important;font-size:36px !important;line-height:1.02 !important;letter-spacing:0 !important;color:#fff7eb;text-transform:none;}',
    /* Last Call badges hold still (no bob, no rotation) so the Broadway lockup and numbers stay sharp; only the ring spins */
    '.lc-burst-lc{animation:lc-pop-flat .6s cubic-bezier(.3,1.6,.5,1) both;}',
    '@keyframes lc-pop-flat{0%{transform:scale(.3);opacity:0}100%{transform:none;opacity:1}}',
    '.lc-burst-lc .lc-burst-txt{flex-direction:column;}',
    '.lc-bw{display:flex;flex-direction:column;align-items:center;gap:6px;color:#fff7eb;margin-bottom:10px;}',
    '.lc-bw svg{display:block;width:90px;height:auto;overflow:visible;}',
    '.lc-bn{display:flex;flex-direction:column;align-items:center;line-height:1;}',
    '.lc-bn .lc-count{font-family:"Recoleta-SemiBold",Georgia,serif !important;font-size:46px !important;letter-spacing:0 !important;color:#E55D5C;line-height:.95;}',
    '.lc-bn small{margin-top:5px;font:700 11px/1.1 "greycliff-cf",Arial,sans-serif !important;letter-spacing:.08em !important;text-transform:uppercase;color:#f9c9c6;}',
    '.lc-eyebrow{display:inline-flex;align-items:center;gap:10px;padding:8px 16px;border:1.5px solid var(--lc-coral);border-radius:999px;color:var(--lc-pink);font:800 13px/1 "greycliff-cf",Arial,sans-serif;letter-spacing:.14em;text-transform:uppercase;}',
    '.lc-dot{width:9px;height:9px;border-radius:50%;background:var(--lc-coral);box-shadow:0 0 0 0 rgba(229,93,92,.7);animation:lc-pulse 1.6s infinite;}',
    '@keyframes lc-pulse{0%{box-shadow:0 0 0 0 rgba(229,93,92,.7)}70%{box-shadow:0 0 0 12px rgba(229,93,92,0)}100%{box-shadow:0 0 0 0 rgba(229,93,92,0)}}',
    '.lc-hero h2{font-family:"Recoleta-SemiBold","Recoleta",Georgia,serif;font-size:clamp(34px,5.4vw,64px);line-height:1.05;margin:22px auto 8px;max-width:900px;color:var(--lc-cream);}',
    '.lc-sub{font:500 18px/1.5 "greycliff-cf",Arial,sans-serif;color:var(--lc-pink);margin:0 auto 30px;max-width:640px;}',
    '.lc-clock-label{font:800 13px/1 "greycliff-cf",Arial,sans-serif;letter-spacing:.16em;text-transform:uppercase;color:var(--lc-coral);margin-bottom:14px;}',
    '.lc-clock{display:flex;justify-content:center;gap:12px;margin-bottom:36px;}',
    '.lc-unit{min-width:92px;padding:16px 8px 12px;background:#1d1a19;border:1px solid #3a2f2d;border-radius:14px;}',
    '.lc-num{display:block;font-family:"Recoleta-SemiBold","Recoleta",Georgia,serif;font-size:48px;line-height:1;color:var(--lc-cream);font-variant-numeric:tabular-nums;}',
    '.lc-unit.lc-sec .lc-num{color:var(--lc-coral);}',
    '.lc-num.lc-tick{animation:lc-tick .35s ease-out;}',
    '@keyframes lc-tick{0%{transform:translateY(-10px);opacity:.2}100%{transform:none;opacity:1}}',
    '.lc-lab{display:block;margin-top:8px;font:700 11px/1 "greycliff-cf",Arial,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#a89893;}',
    '.lc-tiles{display:grid;grid-template-columns:repeat(3,minmax(0,220px));justify-content:center;gap:14px;margin:0 auto 34px;}',
    '.lc-tile{display:block;position:relative;padding:18px 14px 16px;border-radius:14px;background:var(--lc-cream);color:var(--lc-ink);text-decoration:none;transition:transform .15s ease,box-shadow .15s ease;}',
    '.lc-tile:hover{transform:translateY(-3px);box-shadow:0 10px 24px rgba(229,93,92,.35);}',
    '.lc-tile-name{display:block;font:800 13px/1.3 "greycliff-cf",Arial,sans-serif;min-height:34px;}',
    '.lc-tile-num{display:block;font-family:"Recoleta-SemiBold","Recoleta",Georgia,serif;font-size:40px;line-height:1;color:var(--lc-coral);margin-top:6px;font-variant-numeric:tabular-nums;}',
    '.lc-tile-lab{display:block;font:600 12px/1.3 "greycliff-cf",Arial,sans-serif;color:#806f68;margin-top:4px;}',
    '.lc-fewest{position:absolute;top:-10px;left:50%;transform:translateX(-50%);white-space:nowrap;padding:4px 10px;border-radius:999px;background:var(--lc-deep);color:#fff;font:800 10px/1 "greycliff-cf",Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;}',
    '.lc-cta{display:inline-block;padding:17px 38px;border-radius:999px;background:var(--lc-coral);color:#fff !important;font:800 15px/1 "greycliff-cf",Arial,sans-serif;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;animation:lc-glow 2.4s ease-in-out infinite;}',
    '.lc-cta:hover{background:var(--lc-deep);}',
    '@keyframes lc-glow{0%,100%{box-shadow:0 0 0 0 rgba(229,93,92,0)}50%{box-shadow:0 0 26px 4px rgba(229,93,92,.55)}}',
    '.lc-fine{margin-top:16px;font:500 13px/1.4 "greycliff-cf",Arial,sans-serif;color:#a89893;}',
    /* compact strip (shop page) */
    '.lc-strip{background:var(--lc-ink);color:var(--lc-cream);display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:10px 22px;padding:16px 16px;text-align:center;font:800 14px/1.2 "greycliff-cf",Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;}',
    '.lc-strip .lc-mini{font-family:"Recoleta-SemiBold","Recoleta",Georgia,serif;font-size:24px;letter-spacing:0;text-transform:none;color:var(--lc-cream);font-variant-numeric:tabular-nums;}',
    '.lc-strip .lc-mini b{color:var(--lc-coral);font-weight:inherit;}',
    '.lc-strip a{color:var(--lc-pink) !important;text-decoration:underline;text-underline-offset:3px;}',
    /* sticky bar (home) */
    '.lc-sticky{position:fixed;left:0;right:0;bottom:0;z-index:999;display:flex;align-items:center;justify-content:center;gap:14px;padding:11px 14px;background:var(--lc-coral);color:#fff;font:800 13px/1.2 "greycliff-cf",Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;transform:translateY(110%);transition:transform .35s ease;}',
    '.lc-sticky.lc-show{transform:none;}',
    '.lc-sticky .lc-mini{font-variant-numeric:tabular-nums;letter-spacing:.02em;}',
    '.lc-sticky a{color:var(--lc-ink) !important;background:var(--lc-cream);padding:8px 14px;border-radius:999px;text-decoration:none;white-space:nowrap;}',
    /* card tags */
    '.lc-tagwrap{position:relative;}',
    '.lc-tag{position:absolute;top:14px;left:14px;z-index:5;display:inline-flex;align-items:center;gap:7px;padding:8px 13px;border-radius:999px;background:var(--lc-coral);color:#fff;font:800 12px/1 "greycliff-cf",Arial,sans-serif;letter-spacing:.06em;text-transform:uppercase;box-shadow:0 4px 14px rgba(0,0,0,.18);pointer-events:none;}',
    '.lc-tag .lc-dot{width:7px;height:7px;background:#fff;animation:lc-pulse-w 1.6s infinite;}',
    '@keyframes lc-pulse-w{0%{box-shadow:0 0 0 0 rgba(255,255,255,.8)}70%{box-shadow:0 0 0 9px rgba(255,255,255,0)}100%{box-shadow:0 0 0 0 rgba(255,255,255,0)}}',
    '.lc-tag.lc-halo{background:var(--lc-cream);color:var(--lc-ink);border:1.5px solid var(--lc-ink);}',
    '.lc-tag.lc-inline{position:static;margin-bottom:14px;box-shadow:none;}',
    /* the theme forces greycliff and wide tracking on spans, so the display numbers need !important */
    '.lc-hero .lc-num,.lc-hero .lc-tile-num,.lc-strip .lc-mini{font-family:"Recoleta-SemiBold",Georgia,serif !important;letter-spacing:0 !important;}',
    '.lc-hero h2{letter-spacing:.5px !important;}',
    '.lc-tag{font-size:13px !important;padding:9px 14px !important;letter-spacing:.05em !important;}',
    '.lc-tag span.lc-count{letter-spacing:0 !important;font-variant-numeric:normal;}',
    '.lc-eyebrow,.lc-tag,.lc-cta,.lc-fewest,.lc-clock-label,.lc-sticky,.lc-strip{font-weight:700 !important;}',
    '@media (max-width:900px){',
    '.lc-grid{grid-template-columns:1fr 1fr;grid-template-areas:"l r" "c c";gap:18px 14px;}',
    '.lc-side{max-width:190px;}',
    '.lc-side img{aspect-ratio:4/5;border-radius:18px;}',
    '}',
    '@media (max-width:640px){',
    '.lc-hero{padding:40px 16px 44px;}',
    '.lc-burst{width:150px;height:150px;top:10px;left:10px;}',
    '.lc-burst-txt{font-size:23px !important;}',
    '.lc-bw{gap:4px;margin-bottom:6px;}',
    '.lc-bw svg{width:56px;}',
    '.lc-bn .lc-count{font-size:28px !important;}',
    '.lc-bn small{font-size:8px !important;}',
    '.lc-sub{font-size:16px;}',
    '.lc-clock{gap:7px;}',
    '.lc-unit{min-width:0;flex:1 1 0;max-width:80px;padding:12px 4px 10px;}',
    '.lc-num{font-size:32px;}',
    '.lc-lab{font-size:9px;}',
    '.lc-tiles{grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;}',
    '.lc-tile{padding:16px 8px 12px;}',
    '.lc-tile-name{font-size:11px;min-height:42px;}',
    '.lc-tile-num{font-size:28px;}',
    '.lc-tile-lab{font-size:10px;}',
    '.lc-fewest{font-size:8px;padding:4px 7px;}',
    '.lc-tag{top:10px;left:10px;font-size:10px;padding:7px 10px;}',
    '.lc-sticky{font-size:11px;gap:10px;}',
    '}',
    '@media (prefers-reduced-motion:reduce){.lc-hero::before,.lc-dot,.lc-cta,.lc-num.lc-tick,.lc-tag .lc-dot,.lc-side img,.lc-burst,.lc-spin{animation:none !important;}}'
  ].join('\n');

  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function remaining() {
    var ms = Math.max(0, DEADLINE - Date.now());
    var s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60, done: ms <= 0 };
  }

  /* Numbers roll down to the real figure once when they scroll into view. They never go below it,
     and they never tick down afterwards: the only number that settles on screen is the real one. */
  function rollTo(el, target) {
    if (REDUCED || !('IntersectionObserver' in window)) { el.textContent = fmt(target); return; }
    var start = target + Math.max(25, Math.round(target * 0.08));
    el.textContent = fmt(target);
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || document.hidden) return;
      io.disconnect();
      var t0 = null, dur = 1700;
      el.textContent = fmt(start);
      setTimeout(function () { el.textContent = fmt(target); }, dur + 300);
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(Math.round(start - (start - target) * eased));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, { threshold: 0.4 });
    io.observe(el);
  }

  var clocks = [];
  function tickAll() {
    var r = remaining();
    if (r.done) { clocks.forEach(function (c) { c.root.remove(); }); clocks = []; return; }
    clocks.forEach(function (c) { c.render(r); });
  }

  function bigClock(root) {
    var els = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { els[k] = root.querySelector('[data-u="' + k + '"]'); });
    var last = {};
    return { root: root.closest('[data-lc-block]') || root, render: function (r) {
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var v = k === 'd' ? String(r[k]) : pad(r[k]);
        if (last[k] !== v) {
          els[k].textContent = v;
          if (!REDUCED && last[k] !== undefined) { els[k].classList.remove('lc-tick'); void els[k].offsetWidth; els[k].classList.add('lc-tick'); }
          last[k] = v;
        }
      });
    } };
  }

  function miniClock(el, block) {
    return { root: block, render: function (r) { el.textContent = r.d + 'd ' + pad(r.h) + 'h ' + pad(r.m) + 'm ' + pad(r.s) + 's'; } };
  }

  function stockOf(h) { return typeof STOCK[h] === 'number' ? STOCK[h] : null; }

  var IMG = 'https://cdn.shopify.com/s/files/1/0732/6557/8219/files/';
  var SIDES = [
    { handle: 'strawberry-hibiscus', src: IMG + 'Strawberry_Hibiscus_Tea_Flavor_copy.png?width=900', alt: 'hightail Strawberry Hibiscus Tea with fresh strawberries' },
    { handle: 'cocoa-pomegranate-yuzu', src: IMG + 'Cocoa_Pomegranate_Yuzu_Flavor_copy.png?width=900', alt: 'hightail Cocoa Pomegranate Yuzu with pomegranate' }
  ];
  function sideImg(side, im) {
    return '<a class="lc-side lc-side-' + side + '" href="/products/' + im.handle + '"><img src="' + im.src + '" alt="' + im.alt + '" loading="eager"></a>';
  }

  function heroHTML() {
    var counts = FLAVORS.map(function (f) { return stockOf(f.handle); }).filter(function (n) { return n !== null; });
    var min = counts.length ? Math.min.apply(null, counts) : null;
    var tiles = FLAVORS.map(function (f) {
      var n = stockOf(f.handle);
      if (n === null) return '';
      return '<a class="lc-tile" href="/products/' + f.handle + '">' +
        (n === min ? '<span class="lc-fewest">Fewest left</span>' : '') +
        '<span class="lc-tile-name">' + f.name + '</span>' +
        '<span class="lc-tile-num" data-roll="' + n + '">' + fmt(n) + '</span>' +
        '<span class="lc-tile-lab">four-packs left</span></a>';
    }).join('');
    return '<section class="lc-hero" data-lc-block><div class="lc-grid">' +
      sideImg('l', SIDES[0]) +
      '<div class="lc-center">' +
      '<span class="lc-eyebrow"><span class="lc-dot"></span>Last call for hightail infused</span>' +
      '<h2>Stock up while we can still ship to you.</h2>' +
      '<p class="lc-sub">The law is changing, and we can’t ship hightail infused from our site much longer. Reserve now for up to 35% off, with free shipping on every drop.</p>' +
      '<div class="lc-clock-label">Reserve closes in</div>' +
      '<div class="lc-clock">' +
        '<div class="lc-unit"><span class="lc-num" data-u="d">0</span><span class="lc-lab">Days</span></div>' +
        '<div class="lc-unit"><span class="lc-num" data-u="h">00</span><span class="lc-lab">Hours</span></div>' +
        '<div class="lc-unit"><span class="lc-num" data-u="m">00</span><span class="lc-lab">Min</span></div>' +
        '<div class="lc-unit lc-sec"><span class="lc-num" data-u="s">00</span><span class="lc-lab">Sec</span></div>' +
      '</div>' +
      '<div class="lc-tiles">' + tiles + '</div>' +
      '<a class="lc-cta" href="/products/mix-match-pack">Reserve yours</a>' +
      '<div class="lc-fine">Reserve closes October 7 at 11:59pm ET.</div>' +
      '</div>' +
      sideImg('r', SIDES[1]) +
    '</div></section>';
  }

  function flavorTag(n) {
    return '<span class="lc-tag"><span class="lc-dot"></span>Last call &middot; <span class="lc-count" data-roll="' + n + '">' + fmt(n) + '</span> left</span>';
  }
  var ringId = 0;
  /* Big circular badge: spinning ring text around a bold center. */
  function burst(o) {
    var id = 'lc-ring-' + (++ringId);
    return '<span class="lc-burst ' + (o.cls || '') + '" aria-label="' + o.label + '">' +
      '<svg viewBox="0 0 200 200" aria-hidden="true"><defs><path id="' + id + '" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0"/></defs>' +
      '<circle cx="100" cy="100" r="99" fill="' + o.fill + '"/><circle cx="100" cy="100" r="93" fill="none" stroke="' + o.stroke + '" stroke-width="3"/>' +
      '<g class="lc-spin"><text><textPath href="#' + id + '" startOffset="0">' + o.ring + '</textPath></text></g></svg>' +
      '<span class="lc-burst-txt">' + o.center + '</span></span>';
  }
  var HALO_TAG = burst({ label: 'halo is not going anywhere', fill: '#0f0f0f', stroke: '#E55D5C',
    ring: 'HALO IS HERE TO STAY ✦ HALO IS HERE TO STAY ✦ ', center: 'Not going<br>anywhere' });
  /* "LAST CALL" in Broadway, the brand standard (matches the email banner), as outlines so no font is needed */
  var BW = {"LAST": {"vb": "116 422 5485 1489", "d": "M731 504 727 713 723 1046 724 1289 728 1804 800 1805 1228 1799 1306 1798Q1365 1798 1365 1833Q1365 1864 1333 1867Q1326 1868 1287 1869H116L119 1489L121 1256L123 992L119 590L120 504ZM2196 422 2996 1869H2303L2208 1686H1872L1576 1685L1526 1684L1460 1806Q1431 1861 1420 1874Q1408 1888 1391 1888Q1357 1888 1357 1858Q1357 1845 1376 1810Q1396 1774 1513 1576L2118 557ZM1885 1077 1710 1372 1570 1615 1870 1619 2171 1616ZM3073 1637Q3091 1637 3115 1664Q3190 1746 3298 1796Q3407 1845 3513 1845Q3630 1845 3630 1774Q3630 1729 3589 1672Q3548 1616 3393 1449Q3198 1238 3133 1136Q3047 1001 3047 879Q3047 695 3211 578Q3372 463 3608 463Q3773 463 3911 530Q3963 556 4000 590Q4038 624 4038 647Q4038 658 4028 668Q4017 677 4006 677Q3989 677 3956 646Q3902 595 3814 562Q3726 528 3645 528Q3595 528 3564 550Q3532 571 3532 605Q3532 646 3571 705Q3610 764 3703 862Q3997 1175 4063 1284Q4132 1399 4132 1506Q4132 1597 4083 1678Q4034 1759 3947 1811Q3781 1910 3542 1910Q3322 1910 3155 1796Q3038 1716 3038 1671Q3038 1658 3048 1648Q3059 1637 3073 1637ZM5212 571 5207 884 5204 1181 5207 1869H4597L4603 1072L4600 801L4597 571L4465 574L4276 578L4248 579Q4200 579 4200 543Q4200 511 4228 507Q4236 505 4277 504H5504Q5568 505 5580 510Q5600 518 5600 544Q5600 578 5549 578L5462 575L5232 571Z", "ratio": 3.685}, "CALL": {"vb": "55 422 5727 1489", "d": "M701 531 696 1240 701 1842Q753 1849 787 1849Q885 1849 988 1814Q1091 1779 1170 1719Q1221 1680 1276 1615Q1330 1550 1363 1488Q1382 1452 1404 1452Q1437 1452 1437 1480Q1437 1510 1388 1582Q1338 1653 1279 1710Q1151 1833 978 1881Q874 1910 778 1910Q638 1910 497 1850Q271 1755 153 1549Q55 1378 55 1186Q55 990 157 816Q266 631 465 533Q610 463 778 463Q1066 463 1276 658Q1376 751 1376 792Q1376 803 1366 812Q1356 821 1344 821Q1324 821 1296 782Q1210 663 1069 594Q928 524 771 524Q734 524 701 531ZM2271 422 3071 1869H2378L2283 1686H1947L1651 1685L1601 1684L1535 1806Q1506 1861 1494 1874Q1483 1888 1466 1888Q1432 1888 1432 1858Q1432 1845 1452 1810Q1471 1774 1588 1576L2193 557ZM1960 1077 1785 1372 1645 1615 1945 1619 2246 1616ZM3776 504 3772 713 3768 1046 3769 1289 3773 1804 3845 1805 4273 1799 4351 1798Q4410 1798 4410 1833Q4410 1864 4378 1867Q4371 1868 4332 1869H3161L3164 1489L3166 1256L3168 992L3164 590L3165 504ZM5147 504 5143 713 5139 1046 5140 1289 5144 1804 5216 1805 5644 1799 5722 1798Q5781 1798 5781 1833Q5781 1864 5749 1867Q5742 1868 5703 1869H4532L4535 1489L4537 1256L4539 992L4535 590L4536 504Z", "ratio": 3.848}};
  function bwWord(w) {
    return '<svg viewBox="' + BW[w].vb + '" aria-hidden="true"><path fill="currentColor" d="' + BW[w].d + '"/></svg>';
  }
  var LAST_CALL_MARK = '<span class="lc-bw">' + bwWord('LAST') + bwWord('CALL') + '</span>';
  function lastCallBurst(n, unit) {
    var num = n === null ? '' :
      '<span class="lc-bn"><span class="lc-count" data-roll="' + n + '">' + fmt(n) + '</span><small>' + unit + '</small></span>';
    return burst({ label: 'Last call' + (n === null ? '' : ', ' + n + ' ' + unit), cls: 'lc-burst-lc', fill: '#0f0f0f', stroke: '#E55D5C',
      ring: 'STOCK UP NOW ✦ STOCK UP NOW ✦ STOCK UP NOW ✦ ', center: LAST_CALL_MARK + num });
  }

  function tagCard(card, html) {
    if (!card || card.querySelector('.lc-tag,.lc-burst')) return;
    card.classList.add('lc-tagwrap');
    card.insertAdjacentHTML('afterbegin', html);
  }

  function initHome(main) {
    if (open) {
      main.insertAdjacentHTML('afterbegin', heroHTML());
      var hero = main.querySelector('.lc-hero');
      clocks.push(bigClock(hero));

      document.body.insertAdjacentHTML('beforeend',
        '<div class="lc-sticky" data-lc-block><span>Reserve closes in <span class="lc-mini"></span></span><a href="/products/mix-match-pack">Reserve yours</a></div>');
      var sticky = document.querySelector('.lc-sticky');
      clocks.push(miniClock(sticky.querySelector('.lc-mini'), sticky));
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { sticky.classList.toggle('lc-show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(hero);
      }
    }
    FLAVORS.forEach(function (f) {
      var n = stockOf(f.handle);
      if (n === null) return;
      tagCard(document.querySelector('a.flavor-card[href*="/products/' + f.handle + '"]'), flavorTag(n));
    });
    var haloBtn = document.querySelector('a.halo-btn[href*="/products/halo"]');
    var haloRow = haloBtn && haloBtn.closest('.halo-left');
    tagCard(haloRow && haloRow.parentElement.querySelector('.halo-right'), HALO_TAG);
  }

  function initShop(main) {
    if (open) {
      main.insertAdjacentHTML('afterbegin',
        '<div class="lc-strip" data-lc-block><span><span class="lc-dot" style="display:inline-block;margin-right:8px;vertical-align:middle"></span>Last call for infused</span>' +
        '<span class="lc-mini">Reserve closes in <b></b></span>' +
        '<span>Up to 35% off, free shipping</span></div>');
      var strip = main.querySelector('.lc-strip');
      clocks.push(miniClock(strip.querySelector('.lc-mini b'), strip));
    }
    function imgBoxFor(handle) {
      var a = document.querySelector('main a.image-zoom[href*="/products/' + handle + '"]');
      return a && (a.closest('.img-box') || a.parentElement);
    }
    FLAVORS.forEach(function (f) {
      var n = stockOf(f.handle);
      if (n !== null) tagCard(imgBoxFor(f.handle), lastCallBurst(n, 'four-packs left'));
    });
    PACKS.forEach(function (p) {
      var counts = p.of.map(stockOf);
      var n = counts.indexOf(null) === -1 ? Math.min.apply(null, counts) : null;
      tagCard(imgBoxFor(p.handle), lastCallBurst(n, p.unit));
    });
    tagCard(imgBoxFor('halo'), HALO_TAG);
  }

  function init() {
    if (document.getElementById('lc-style')) return;
    var st = document.createElement('style');
    st.id = 'lc-style';
    st.textContent = CSS;
    document.head.appendChild(st);
    var main = document.querySelector('main') || document.body;
    if (D.page === 'shop') initShop(main); else initHome(main);
    document.querySelectorAll('[data-roll]').forEach(function (el) { rollTo(el, Number(el.getAttribute('data-roll'))); });
    tickAll();
    setInterval(tickAll, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
